import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=57beec76&scoped=true&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=57beec76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beec76",
  null
  
)

export default component.exports